<template>
  <div class="message-view-container">
    <div class="logo-container">
      <img class="logo-img" src="../../../assets/images/home/logo@2x.png" />
      <div class="border-div" @click="handleClick">
        <img src="../../../assets/images/home/img3.png" class="border-img" alt="">
        <input type="text" readonly class="border-input" placeholder="智能搜索">
        <div class="border-btn">
          <img src="../../../assets/images/home/img4.png" class="icon-search" alt="">
          <span class="btn-txt">搜索</span>
        </div>
      </div>
      <!-- <van-search right-icon="" shape="round" placeholder="搜索内容" :clearable="true" clear-trigger="always" @click="handleClick">
        <template #left-icon>
          <van-icon name="search" />
        </template>
</van-search>
<img src="@/assets/images/home/img1.png" @click="handleClickAI" v-if="`${userInfo.memberType}` === '1'" class="img-ai"
  alt=""> -->
    </div>
  </div>
</template>

<script>
import { BOOL_GOAL, BOOL_NON_GOAL, BOOL_NON_EP, BOOL_SENIOR_EMPLOYEE, BOOL_SENIOR, BOOL_EMPLOYEE } from '@/utils/configRoles'
import { traceClickURL } from '@/utils/util'
export default {
  name: 'home-header',
  data () {
    return {
    }
  },
  computed: {
    defaultHead () {
      if (BOOL_GOAL || BOOL_NON_GOAL || BOOL_NON_EP) {
        return require('../../../assets/images/home/student-head.png')
      } else if (BOOL_SENIOR_EMPLOYEE || BOOL_SENIOR) {
        return require('../../../assets/images/home/teacher-head.png')
      } else if (BOOL_EMPLOYEE) {
        return require('../../../assets/images/home/other-roles-head.png')
      } else {
        return require('../../../assets/images/home/other-roles-head.png')
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    // 是否为目标EP术者
    rolePower () {
      return BOOL_GOAL
    }
  },
  methods: {
    handleClick () {
      this.$router.push({
        path: '/pageSearch'
      })
    },
    onCourseSearchEnter () {
      console.log(1)
    },
    clearSearchValue () {
      console.log(2)
    },
    // 强生QA环境机器人访问地址如下：
    // pc
    // https://qa.genai.jjmc.cn/bwhcpsa/chat?access_token=
    // 移动端
    // https://qa.genai.jjmc.cn/bwhcpsa/chat
    handleClickAI () {
      setTimeout(() => { traceClickURL() })
      window.location.href = 'https://qa.genai.jjmc.cn/bwhcpsa/chat'
    }
  }
}
</script>

<style lang="less" scoped>
.message-view-container {
  position: relative;
  width: 100%;
  margin-bottom: 8px;

  .logo-container {
    height: 48px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 14px;
    box-sizing: border-box;

    .logo-img {
      width: 24px;
      display: block;
      margin-right: 10px;
    }

    .border-div {
      display: flex;
      align-items: center;
      background: #F9F8F7;
      height: 32px;
      padding: 3px;
      box-sizing: border-box;
      border-radius: 25px;
      flex: 1;

      .border-img {
        width: 34px;
        display: block;
        margin-right: 2px;
        padding-left: 6px;
        box-sizing: border-box;
      }

      .border-input {
        border: none;
        outline: none;
        color: #949BA5;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 13px;
        background-color: transparent;
        flex: 1;
      }

      .border-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 26px;
        border-radius: 25px;
        background: rgba(213, 207, 201, 0.5);

        .icon-search {
          width: 13px;
          display: block;
          margin-right: 4px;
        }

        .btn-txt {
          color: #000000;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 13px;
        }
      }
    }

    /deep/ .van-search {
      padding: 0;
      flex: 1;
    }
  }
}

.img-ai {
  height: 28px;
  width: auto;
  display: block;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/HomeHeader.vue